import { createContext, useContext } from "react";

export const TEMPLATES_MODAL_TYPE = {
  LIST: "list",
  EDITOR: "editor",
  PRODUCE: "produce",
};

export const TemplatesModalsContext = createContext(null);

export const useTemplatesModals = () => {
  const value = useContext(TemplatesModalsContext);
  if (!value) {
    throw new Error(
      "useTemplatesModals must be used within TemplatesModalsProvider"
    );
  }
  return value;
};
